import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Flex, Title } from '@mantine/core';
import React from 'react';
import { QuickSwitchBreadcrumbsNav } from '@dealstack/frontend/shared/components/QuickSwitchBreadcrumbsNav/QuickSwitchBreadcrumbsNav.tsx';

interface Props {
	children?: React.ReactNode;
	sidebar?: React.ReactNode;
	title?: string;
	showBreadcrumbs?: boolean;
	width?: React.CSSProperties['width'];
	titleDataTestId?: string;
}

export const DashboardLayout = ({
	title,
	children,
	sidebar,
	width = '25%',
	showBreadcrumbs = false,
	titleDataTestId,
}: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();
	return (
		<Flex direction="column" mih="100%" px="2rem" py="1rem">
			<Flex direction="column" gap="1rem">
				{showBreadcrumbs && <QuickSwitchBreadcrumbsNav />}
				<Title order={3} fw={600} c="dark.8" data-testid={titleDataTestId}>
					{title || tAdminDashboard('deal.title')}
				</Title>
			</Flex>
			<Flex
				gap="1rem"
				mt="1.5rem"
				align="start"
				style={{
					flex: 1,
					overflow: 'hidden',
				}}
			>
				{sidebar && (
					<Flex
						align="flex-start"
						w={width}
						sx={{ height: '100%', overflow: 'hidden auto' }}
					>
						{sidebar}
					</Flex>
				)}
				<Flex h="100%" sx={{ flex: 1, overflow: 'hidden auto' }}>
					{children}
				</Flex>
			</Flex>
		</Flex>
	);
};
